import type { AppDispatch } from '@src/store';
import { baseDroneApi } from '@src/core/features/drone/redux/api';

/**
 * Refresh the GET /drone list after mutations that change drone status or mission linkage.
 * Invalidating the tag refetches every active subscription regardless of its status filter
 * (the drones page subscribes via DroneProvider), so no manual per-arg refetch is needed.
 */
export function refetchDronesCache(dispatch: AppDispatch): void {
  dispatch(baseDroneApi.util.invalidateTags(['GetDrones']));
}
